import { type ComponentType, lazy } from 'react';

export function lazyAnalytics<T extends ComponentType<object>>(
    loader: () => Promise<{ default: T }>,
) {
    return lazy(() =>
        loader().catch((error: unknown) => {
            console.error('Analytics module load failed', error);
            return { default: (() => null) as unknown as T };
        }),
    );
}
